<template>
  <div class="header">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col-auto">
          <h6
            class="header-pretitle text-primary cursor-pointer"
            @click="handleGoBack"
            v-if="goBackConfig"
          >
            <i class="fa-solid fa-arrow-left"></i>
            Voltar
          </h6>
          <h1 class="header-title text-truncate">{{ title }}</h1>
        </div>
        <div class="col header-right-content" :class="`offset-${offset}`">
          <slot />
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col">
          <ul class="nav nav-tabs nav-overflow header-tabs">
            <li
              class="nav-item cursor-pointer"
              v-for="(tab, index) in tabsArr"
              :key="index"
            >
              <a
                @click.prevent="onChangeTab(tab)"
                class="nav-link text-nowrap"
                :class="{ active: tab.active }"
                :id="`${tab.id}_tab`"
              >
                {{ tab.title }}
                <span
                  class="badge rounded-pill text-bg-secondary-subtle"
                  v-if="tab.count"
                  >{{ tab.count }}</span
                >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import { HeaderProps, HeaderTab } from "@/types";
import { ref } from "vue";
import router from "@/presentation/router";

export type HeaderProps = {
  title: string;
  tabs?: HeaderTab[];
  offset?: string;
  goBackConfig?: {
    name: string;
    params?: any;
  };
};

export type HeaderTab = {
  id: string;
  title: string;
  count?: number;
  active: boolean;
  to: string;
  params: any;
};

const {
  title = "",
  goBackConfig = null,
  tabs = [],
  offset = "auto",
} = defineProps<HeaderProps>();
const tabsArr = ref(tabs);

const onChangeTab = (tab: HeaderTab) => {
  tabsArr.value = tabsArr.value.map((elem: HeaderTab) => ({
    ...elem,
    active: tab.id === elem.id,
  }));
  const routeConfig: any = { name: tab.to };
  if (tab.params) routeConfig["params"] = tab.params;
  router.push(routeConfig);
};

const handleGoBack = () => {
  if (goBackConfig) router.push(goBackConfig);
};
</script>

<style>
.header-right-content > :first-child {
  margin-left: auto;
}
</style>
